/** Carousel timing — 6s auto-advance */
export const WELLNESS_CAROUSEL_INTERVAL_MS = 6000;
export const WELLNESS_DESIGN = {
    heroRadiusPx: 32,
    glassBlurPx: 20,
};
export const VISITOR_HERO_HEADLINE = 'Find support that understands you.';
export const VISITOR_HERO_SUBLINE = 'Connect with licensed therapists and begin your healing journey in a safe, confidential space.';
export const CLIENT_DASHBOARD_TAGLINE = 'Your wellbeing matters.';
export const THERAPIST_DASHBOARD_HEADLINE = 'Changing lives one conversation at a time.';
export const THERAPIST_DASHBOARD_SUBLINE = 'Sessions, notes, and the people you support.';
export const ADMIN_DASHBOARD_HEADLINE = 'Empowering mental wellness at scale.';
export const ADMIN_DASHBOARD_SUBLINE = 'Every decision here helps someone find care and grow.';
/** Optimised Pexels CDN URL for carousel slides */
export function wellnessPexelsUrl(photoId, width = 1400) {
    return `https://images.pexels.com/photos/${photoId}/pexels-photo-${photoId}.jpeg?auto=compress&cs=tinysrgb&w=${width}&h=1050&fit=crop`;
}
export const WELLNESS_SLIDES = [
    {
        id: 'meditation',
        caption: 'Stillness — a quiet moment to breathe',
        imageUrl: wellnessPexelsUrl(3822621),
        gradient: ['#1A4A58', '#215667', '#7EC4CB'],
    },
    {
        id: 'connection',
        caption: 'Gentle movement — yoga for body and mind',
        imageUrl: wellnessPexelsUrl(3822863),
        gradient: ['#0E2229', '#215667', '#B7E4E6'],
    },
    {
        id: 'selfcare',
        caption: 'Peace found in nature and reflection',
        imageUrl: wellnessPexelsUrl(4056535),
        gradient: ['#1A4A58', '#215667', '#EDE1C8'],
    },
    {
        id: 'reflection',
        caption: 'Calm confidence — wellness from within',
        imageUrl: wellnessPexelsUrl(3822906),
        gradient: ['#1A4A58', '#2A697B', '#D7F3F4'],
    },
    {
        id: 'comfort',
        caption: 'Rest and ease — you deserve this pause',
        imageUrl: wellnessPexelsUrl(6473792),
        gradient: ['#2A697B', '#4A96A6', '#F0FBFB'],
    },
    {
        id: 'listening',
        caption: 'Mindful presence — grounded and serene',
        imageUrl: wellnessPexelsUrl(6476589),
        gradient: ['#2A697B', '#215667', '#2A697B'],
    },
    {
        id: 'notes',
        caption: 'Mindfulness — centre yourself with intention',
        imageUrl: wellnessPexelsUrl(4056723),
        gradient: ['#2A697B', '#1A4A58', '#7EC4CB'],
    },
    {
        id: 'video',
        caption: 'Balance — strength through gentle practice',
        imageUrl: wellnessPexelsUrl(3823493),
        gradient: ['#142E38', '#2A697B', '#4A96A6'],
    },
    {
        id: 'community',
        caption: 'Shared calm — wellness together',
        imageUrl: wellnessPexelsUrl(1181717),
        gradient: ['#142E38', '#215667', '#7EC4CB'],
    },
    {
        id: 'abstract',
        caption: 'Inner peace — healing at your own pace',
        imageUrl: wellnessPexelsUrl(3822622),
        gradient: ['#0E2229', '#2A697B', '#B7E4E6'],
    },
];
/** Landing + marketing hero — calm, meditation, yoga */
export const LANDING_CAROUSEL_SLIDES = [
    WELLNESS_SLIDES[0],
    WELLNESS_SLIDES[1],
    WELLNESS_SLIDES[2],
    WELLNESS_SLIDES[3],
    WELLNESS_SLIDES[4],
    WELLNESS_SLIDES[8],
];
/** Auth surfaces */
export const AUTH_CAROUSEL_SLIDES = [
    WELLNESS_SLIDES[0],
    WELLNESS_SLIDES[1],
    WELLNESS_SLIDES[2],
    WELLNESS_SLIDES[4],
    WELLNESS_SLIDES[3],
];
/** Dashboard hero strips */
export const CLIENT_DASHBOARD_SLIDES = [
    WELLNESS_SLIDES[0],
    WELLNESS_SLIDES[2],
    WELLNESS_SLIDES[4],
];
export const THERAPIST_DASHBOARD_SLIDES = [
    WELLNESS_SLIDES[5],
    WELLNESS_SLIDES[1],
    WELLNESS_SLIDES[6],
];
export const WELLNESS_PLACEMENT_KEYS = [
    'landing',
    'auth',
    'client_dashboard',
    'therapist_dashboard',
];
export const WELLNESS_PLACEMENT_LABELS = {
    landing: 'Landing page carousel',
    auth: 'Login & signup carousel',
    client_dashboard: 'Client dashboard hero',
    therapist_dashboard: 'Therapist dashboard hero',
};
export const SITE_COPY_KEYS = [
    'visitor.hero.headline',
    'visitor.hero.subline',
    'client.dashboard.tagline',
    'therapist.dashboard.headline',
    'therapist.dashboard.subline',
    'admin.dashboard.headline',
    'admin.dashboard.subline',
];
export const SITE_COPY_LABELS = {
    'visitor.hero.headline': 'Landing hero headline',
    'visitor.hero.subline': 'Landing hero subline',
    'client.dashboard.tagline': 'Client dashboard tagline',
    'therapist.dashboard.headline': 'Therapist dashboard headline',
    'therapist.dashboard.subline': 'Therapist dashboard subline',
    'admin.dashboard.headline': 'Admin dashboard headline',
    'admin.dashboard.subline': 'Admin dashboard subline',
};
export const SITE_COPY_DEFAULTS = {
    'visitor.hero.headline': VISITOR_HERO_HEADLINE,
    'visitor.hero.subline': VISITOR_HERO_SUBLINE,
    'client.dashboard.tagline': CLIENT_DASHBOARD_TAGLINE,
    'therapist.dashboard.headline': THERAPIST_DASHBOARD_HEADLINE,
    'therapist.dashboard.subline': THERAPIST_DASHBOARD_SUBLINE,
    'admin.dashboard.headline': ADMIN_DASHBOARD_HEADLINE,
    'admin.dashboard.subline': ADMIN_DASHBOARD_SUBLINE,
};
const PLACEMENT_SLIDE_FALLBACKS = {
    landing: LANDING_CAROUSEL_SLIDES,
    auth: AUTH_CAROUSEL_SLIDES,
    client_dashboard: CLIENT_DASHBOARD_SLIDES,
    therapist_dashboard: THERAPIST_DASHBOARD_SLIDES,
};
export function buildDefaultWellnessSiteContent() {
    return {
        carouselIntervalMs: WELLNESS_CAROUSEL_INTERVAL_MS,
        placements: { ...PLACEMENT_SLIDE_FALLBACKS },
        copy: { ...SITE_COPY_DEFAULTS },
    };
}
export function getPlacementSlides(content, placement) {
    const fromApi = content?.placements[placement];
    if (fromApi && fromApi.length > 0)
        return fromApi;
    return PLACEMENT_SLIDE_FALLBACKS[placement];
}
export function getSiteCopy(content, key) {
    const value = content?.copy[key];
    if (value?.trim())
        return value;
    return SITE_COPY_DEFAULTS[key];
}
//# sourceMappingURL=wellness.js.map